import PprIcon from './component'

export default PprIcon
